import { Grid } from '@material-ui/core';
import SearchBar from "material-ui-search-bar";
import React, { Component } from 'react';
import { IsAdmin } from "../RightsService"

export default class SourcesToolbar extends Component {
    static displayName = SourcesToolbar.name;

    newButton() {
        if (IsAdmin()) return (
            <button className="btn btn-primary" onClick={this.props.createSourceClicked}>
                Create New Source
            </button>
        )
    }

    render() {
        return (
            <Grid container>
                <Grid item xs={6}>
                    <SearchBar
                        value={this.props.quickFilterText}
                        onChange={this.props.quickFilterTextChanged}
                        onCancelSearch={this.props.quickFilterCanceled}
                        cancelOnEscape={true}
                        style={{ marginBottom: "3px", width: "300px", height: "40px" }}
                    />
                </Grid>
                <Grid item xs={6}>
                    <Grid container justify="flex-end">
                        {this.newButton()}
                    </Grid>
                </Grid>
            </Grid>
        );
    }
}
